import { Capacitor } from '@capacitor/core';
import type { AppTrackingStatus } from 'capacitor-plugin-app-tracking-transparency';

let currentStatus: AppTrackingStatus | null = null;

export function setTrackingStatus(status: AppTrackingStatus | null): void {
  currentStatus = status;
}

export function isTrackingAllowed(): boolean {
  if (Capacitor.getPlatform() !== 'ios') return true;

  return currentStatus === 'authorized';
}
